import {JsonProperty} from '@dhkatz/json-ts';
import {AbstractCombinedPreRenderDataPart} from './abstracts/abstract-combined-pre-render-data-part';

export class CombinedPreRenderDataPart extends AbstractCombinedPreRenderDataPart {

  @JsonProperty('d')
  private _data: string;

  public constructor() {
    super();
    this._data = undefined;
  }

  public get data(): string {
    return this._data;
  }

  public set data(value: string) {
    this._data = value;
  }
}
